import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtUSD } from "../lib/format";
import { PageHeader } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";
import { Progress } from "../components/ui/progress";

export default function Budget() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/budget").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loader />;

  const totalBudget = rows.reduce((s, r) => s + r.annual_budget, 0);
  const totalActual = rows.reduce((s, r) => s + r.actual, 0);

  const columns = [
    { key: "account_number", label: "Acct", className: "font-mono text-[#5C5C54]" },
    { key: "account_name", label: "Line Item" },
    { key: "category", label: "Category", className: "text-[#5C5C54]" },
    { key: "annual_budget", label: "Annual Budget", align: "right", render: (r) => fmtUSD(r.annual_budget) },
    { key: "actual", label: "Actual", align: "right", render: (r) => fmtUSD(r.actual) },
    { key: "variance", label: "Variance", align: "right", render: (r) => (
      <span className={r.variance >= 0 ? "text-inflow" : "text-outflow"}>{fmtUSD(r.variance)}</span>
    )},
    { key: "utilization", label: "Utilization", align: "right", render: (r) => (
      <div className="flex items-center gap-2 justify-end">
        <Progress value={Math.min(r.utilization, 100)} className="w-20 h-1.5" />
        <span className="w-12 text-right">{r.utilization}%</span>
      </div>
    )},
  ];

  return (
    <div>
      <PageHeader title="Budget Management" subtitle="Planned vs. actual spending with live variance analysis." />
      <div className="grid grid-cols-3 gap-6 mb-6">
        {[["Annual Budget", totalBudget], ["Actual Spend", totalActual], ["Remaining", totalBudget - totalActual]].map(([l, v]) => (
          <div key={l} className="bg-white border border-stone-200 rounded-xl p-5">
            <div className="text-xs uppercase tracking-wider text-[#5C5C54]">{l}</div>
            <div className="font-mono text-xl font-semibold mt-1">{fmtUSD(v)}</div>
          </div>
        ))}
      </div>
      <DataTable columns={columns} rows={rows} testid="budget-table" />
    </div>
  );
}
